import { BaseEntity } from "@app/models/rest/base-entity";
import { RosterAssignment } from "@app/models/rest/roster/roster-assignment";
import { Shift } from "@app/models/rest/roster/shift";
import { RosterRunHistoryStatus } from "@app/models/rest/roster/roster-run-history-status";
import { RosterRunHistory } from "@app/models/rest/roster/roster-run-history";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("rosterRunHistoryEntries")
export class RosterRunHistoryEntry extends BaseEntity {
  effectiveDate: Date;
  rosterRunHistory: RosterRunHistory;
  rosterAssignment: RosterAssignment;
  shift: Shift;
  resourceAvailabilityId: number;
  status: RosterRunHistoryStatus;
}
